// pages/Landing.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Landing.css';

const Landing = () => {
  const navigate = useNavigate();

  const handleRegisterClick = () => {
    navigate('/register');
  };

  const handleLoginClick = () => {
    navigate('/login');
  };

  return (
    <div className="landing-container">
      {/* Simple Background */}
      <div className="background">
        <img 
          src="assets/image.jpg" 
          alt="Background" 
          className="bg-image"
        />
        <div className="overlay"></div>
      </div>

      {/* Main Content */}
      <main className="main-content">
        {/* Welcome Section with Title and Image */}
        <div className="welcome-section">
          <div className="welcome-container">
            {/* Title Section */}
            <div className="title-section">
              <div className="title-sequence">
                <h1 className="welcome-text">WELCOME</h1>
                <div className="main-titles">
                  <h1 className="main-title">TO</h1>
                  <h1 className="subtitle">TINUBU-AMBODE</h1>
                  <h1 className="supporters-text">SUPPORTERS PORTAL</h1>
                </div>
              </div>
              
              {/* <div className="tagline">
                <p className="tagline-text">United for Progress • Building Nigeria's Future</p>
              </div> */}
            </div>

            {/* Welcome Image */}
            <div className="welcome-image-section">
              <div className="welcome-image-display">
                <div className="image-frame">
                  <img 
                    src="assets/image.jpg" 
                    alt="Tinubu and Ambode - Visionary Leadership" 
                    className="welcome-image" 
                  />
                </div>
                <div className="image-caption">
                  <span className="caption-text">Visionary Leadership</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Write-up Section */}
        <div className="writeup-section">
          <div className="writeup-container">
            <h2 className="writeup-title">Join the Tinubu–Ambode Movement Today</h2>
            
            <div className="writeup-content">
              <p className="writeup-subtitle">
                Register or log in to show your support and be part of a united front for progress and greatness.
              </p>
              
              <div className="features-list">
                <div className="feature-item">
                  <div className="feature-icon">✓</div>
                  <div className="feature-text">Registration is free, fast, and secure, with your privacy fully protected</div>
                </div>
                
                <div className="feature-item">
                  <div className="feature-icon">✓</div>
                  <div className="feature-text">Receive real-time updates, news, and notifications via SMS and WhatsApp</div>
                </div>
                
                <div className="feature-item">
                  <div className="feature-icon">✓</div>
                  <div className="feature-text">Connect directly with other supporters for collaboration and discussion</div>
                </div>
                
                <div className="feature-item">
                  <div className="feature-icon">✓</div>
                  <div className="feature-text">Stay informed, connected, and committed to our shared vision</div>
                </div>
              </div>
              
              <div className="commitment-section">
                <p className="vision-text">
                  Together, we'll make the Tinubu–Ambode vision a reality.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="action-section">
          <div className="action-buttons">
            <button 
              className="btn primary-btn"
              onClick={handleLoginClick}
            >
              Sign In
            </button>
            <button 
              className="btn secondary-btn"
              onClick={handleRegisterClick}
            >
              Register Now
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Landing;